const MODULE_PREFIX = 'global/companies';

export default {
    SET_COMPANIES: `${MODULE_PREFIX}/SET_COMPANIES`,
};
